"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTriggerField = _interopRequireDefault(require("../cwtriggerfield/CwTriggerField"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _CwDatePicker = _interopRequireDefault(require("./CwDatePicker.scss"));

var _ChangeCheck = _interopRequireDefault(require("../../utils/ChangeCheck"));

var _CwDropdownService = require("../../utils/CwDropdownService");

var _moment = _interopRequireDefault(require("moment"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var _DateUtils = require("../../utils/DateUtils");

var CwDatePicker =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwDatePicker, _React$Component);

  function CwDatePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDatePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDatePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIgnoreBlur", function (ignore) {
      _this._ignoreBlur = ignore;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      window.addEventListener('mousedown', _this.pageClick, false);
      window.addEventListener('scroll', _this.handleScroll, true);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (_this.state.childVisible === true && prevState.childVisible === false) {
        var menuPositions = (0, _CwDropdownService.setMenuPositions)(_this.cwTriggerField.cwTextField.inputField);
        var node = _this.refs.Calendar.div;

        _this.setState({
          menuTop: menuPositions.menuTop,
          menuLeft: menuPositions.menuLeft,
          inputHeight: menuPositions.inputHeight,
          node: node
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleScroll", function () {
      /* istanbul ignore next */
      if (_this.mouseIsDownOnCalendar) {
        return;
      }

      _this.collapseChild();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pageClick", function () {
      /* istanbul ignore next */
      if (_this.mouseIsDownOnCalendar) {
        return;
      }

      _this.collapseChild();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mouseDownHandler", function (blur) {
      _this.mouseIsDownOnCalendar = true;

      _this.setIgnoreBlur(blur);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mouseUpHandler", function () {
      _this.mouseIsDownOnCalendar = false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onValueChange", function (date) {
      var dateOnly = date ? (0, _DateUtils.extractDate)(date, _this.props.isDateTime) : undefined;
      var invalid = date === null ? true : !date.isValid();

      _this.setState({
        date: invalid ? (0, _moment.default)() : date,
        display: invalid ? '' : _this.props.formatter(_this.props.isDateTime ? date : (0, _moment.default)(dateOnly)),
        hasFocus: false
      });

      _this.collapseChild();

      if (invalid) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(date);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTyping", function (value) {
      if (value || value === '') {
        _this.setState({
          display: value,
          hasFocus: true
        });
      }

      if (value) {
        var date = _this.props.isDateTime ? (0, _moment.default)(value, _this.formats, _this.props.locale) : _moment.default.utc(value, _this.formats, _this.props.locale);

        if (date) {
          if (date.isValid()) {
            var invalid = date === null ? true : !date.isValid();

            _this.setState({
              date: invalid ? (0, _moment.default)() : date
            });

            if (invalid) {
              _this.props.onChange(null);
            } else {
              _this.props.onChange(date);
            }

            return;
          }
        }
      }

      _this.props.onChange(null);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTriggerClicked", function () {
      _this.setState(function (prevState) {
        return {
          childVisible: !prevState.childVisible
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function () {
      _this._typing = false;
      if (_this._ignoreBlur) return;

      _this.collapseChild();

      var date = (0, _moment.default)(_this.state.display, _this.formats, _this.props.locale);

      _this.setState({
        display: date.isValid() ? _this.props.formatter(date) : '',
        hasFocus: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFocus", function () {
      _this.setState({
        hasFocus: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      _this._typing = true;

      _this.setIgnoreBlur(false);

      if (_this.keyDownHandlers[event.key]) _this.keyDownHandlers[event.key].call((0, _assertThisInitialized2.default)(_this), event);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleArrowClicks", function (value) {
      _this.setState({
        date: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCalendarHeight", function () {
      if (_this.state.node) {
        return _this.state.node.clientHeight;
      } else {
        return 0;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "calcCalendarPosition", function (settings) {
      var top = settings.top;
      var spaceAbove = top - settings.inputHeight;
      var spaceBelow = window.innerHeight - top; // Calculate the menu height, use the max height if items is more than can fit on one page

      var menuHeight = _this.getCalendarHeight(); // If there's not enough room to fit the full menu below, make adjustments


      if (spaceBelow < menuHeight) {
        // Render above the component if there's enough space
        if (spaceAbove > menuHeight) {
          top = top - menuHeight - settings.inputHeight;
        } // If there's not enough space above but more space below, resize the menu

        /* istanbul ignore next */
        else if (spaceBelow > spaceAbove) {
            menuHeight = window.innerHeight - top;
          } // If there's more space above, resize the menu and display it above

          /* istanbul ignore next */
          else {
              menuHeight = top - settings.inputHeight;
              top = top - menuHeight - settings.inputHeight;
            }
      }

      return {
        top: top,
        menuHeight: menuHeight
      };
    });

    _moment.default.locale(_this.props.locale);

    var _dateOnly = props.value ? (0, _DateUtils.extractDate)(props.value, props.isDateTime) : undefined;

    _this.state = {
      date: props.value ? props.value : (0, _moment.default)(),
      prevDate: (0, _moment.default)(),
      childVisible: false,
      hasFocus: false,
      display: props.value ? _this.props.formatter(props.isDateTime ? props.value : (0, _moment.default)(_dateOnly)) : ''
    };
    _this._typing = false;
    _this._ignoreBlur = false;
    _this.mouseIsDownOnCalendar = false;
    _this.formats = ['YYYY-MM-DDTHH:MM:SSZ', _moment.default.localeData().longDateFormat('L'), _moment.default.localeData().longDateFormat('l'), _moment.default.localeData().longDateFormat('LL'), _moment.default.localeData().longDateFormat('ll'), _moment.default.localeData().longDateFormat('LLL'), _moment.default.localeData().longDateFormat('LLLL'), _moment.default.localeData().longDateFormat('lll'), _moment.default.localeData().longDateFormat('llll')];
    _this.keyDownHandlers = {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault(); // prevent window scrolling

        this.expandChild();
      },
      Enter: function Enter(event) {
        this._typing = false; //Force a blur on enter then regain focus. 

        this.handleBlur(event);
        this.setState({
          hasFocus: true
        });
      },
      Escape: function Escape() {
        this.collapseChild();
      }
    };
    return _this;
  }

  (0, _createClass2.default)(CwDatePicker, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propsToCheck = ['value', 'disabled', 'invalid'];
      var stateToCheck = ['date', 'childVisible', 'hasFocus', 'display'];
      return (0, _ChangeCheck.default)(propsToCheck, this.props, nextProps) || (0, _ChangeCheck.default)(stateToCheck, this.state, nextState) || this.state.prevDate !== nextState.date;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var dateOnly = nextProps.value ? (0, _DateUtils.extractDate)(nextProps.value, this.props.isDateTime) : undefined;

      if (nextProps.value && this._typing === true) {
        this.setState({
          date: this.props.isDateTime ? (0, _moment.default)(dateOnly) : _moment.default.utc(dateOnly),
          prevDate: this.props.value
        });
      } else if (nextProps.value && this._typing === false) {
        this.setState({
          date: this.props.isDateTime ? (0, _moment.default)(dateOnly) : _moment.default.utc(dateOnly),
          prevDate: this.props.value,
          display: this.props.formatter(this.props.isDateTime ? nextProps.value : (0, _moment.default)(dateOnly))
        });
      } else if (!this.state.hasFocus) {
        this.setState({
          display: ''
        });
      }
    }
  }, {
    key: "expandChild",
    value: function expandChild() {
      if (!this.state.childVisible) {
        this.setState({
          childVisible: true
        });
      }
    }
  }, {
    key: "collapseChild",
    value: function collapseChild() {
      if (this.state.childVisible) {
        this.setState({
          childVisible: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.pageClick);
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var calendarSettings = {
        top: this.state.menuTop,
        inputHeight: this.state.inputHeight
      };
      var dropdownPosition = this.calcCalendarPosition(calendarSettings);
      var style = {
        // Pass calculated position coordinates to calendar with inline style
        left: this.state.menuLeft,
        top: dropdownPosition.top
      };
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        onFocus: this.handleFocus,
        className: _CwDatePicker.default.datePickerRoot
      }, _react.default.createElement(_CwTriggerField.default, {
        cwId: this.props.cwId + '_trigger',
        autoFocus: this.props.autoFocus,
        value: this.state.display,
        onFocus: this.handleFocus,
        triggerIcon: this.props.triggerIcon,
        onTrigger: this.onTriggerClicked,
        onBlur: this.handleBlur,
        onChange: this.handleTyping,
        onKeyDown: this.handleKeyDown,
        invalid: this.props.invalid,
        disabled: this.props.disabled,
        ref: function ref(input) {
          return _this2.cwTriggerField = input;
        }
      }), this.state.childVisible ? _react.default.createElement(_Calendar.default, {
        value: this.state.date,
        style: style,
        leftArrow: this.props.leftArrow,
        rightArrow: this.props.rightArrow,
        localToday: this.props.localToday,
        onChange: this.onValueChange,
        onMouseDown: this.mouseDownHandler,
        onMouseUp: this.mouseUpHandler,
        onHeaderClick: this.handleArrowClicks,
        isDateTime: this.props.isDateTime,
        ref: "Calendar"
      }) : null);
    }
  }]);
  return CwDatePicker;
}(_react.default.Component);

CwDatePicker.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   *  Url of the text field trigger
   */
  triggerIcon: _propTypes.default.string,

  /**
   * The localized version of the word today
   */
  localToday: _propTypes.default.string,

  /**
   * url for the left arrow image
   */
  leftArrow: _propTypes.default.string,

  /**
   * url for the right arrow image
   */
  rightArrow: _propTypes.default.string,

  /**
   * An array of localized months
   */
  monthName: _propTypes.default.array,

  /**
   * An array of localized days of the week
   */
  daysOfTheWeek: _propTypes.default.array,

  /**
   * A function that formats the date time object. Should, at the very minmimum call the .toLocalDateString method
   * from the date object
   */
  formatter: _propTypes.default.func.isRequired,

  /**
   * Our initial date, can be null
   */
  value: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_moment.default), _propTypes.default.instanceOf(Date)]),

  /**
   * A function to handle updating the text field should at least update the value
   */
  onChange: _propTypes.default.func,

  /**
   * Used to control if textfield is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * A prop to append to our internal onfocus
   */
  onFocus: _propTypes.default.func,

  /**
   * A prop to append to our internal onBlur
   */
  onBlur: _propTypes.default.func,

  /**
  * Used to control if date picker is valid
  */
  invalid: _propTypes.default.bool,

  /**
   * Used to disable date picker
   */
  disabled: _propTypes.default.bool,
  isDateTime: _propTypes.default.bool
};
CwDatePicker.defaultProps = {
  triggerIcon: _IconPath.default.get('Action_DatePicker'),
  isDateTime: false
};
var _default = CwDatePicker;
exports.default = _default;